import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import {
  OrganizationInterface,
  ReviewInterface,
  ReviewStatInterface,
} from '@sport-activities/sdk';
import { Subscription } from 'rxjs';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Component({
  selector: 'app-attendee-organizer-page',
  templateUrl: './organizer-page.component.html',
  styleUrls: ['./organizer-page.component.scss'],
})
export class AttendeeOrganizerPageComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  public readonly tabBarlinks: TabBarLinkInterface[] = [];
  public readonly toggleNameEnum = ToggleNameEnum;
  public organization: OrganizationInterface;
  public reviews: ReviewInterface[];
  public reviewsStats: ReviewStatInterface;
  constructor(
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ data }) => {
        this.organization = data;
      })
    );

    this.tabBarlinks.push(
      ...['activities', 'reviews'].map((status) => ({
        name: this.translateService.instant(`organizer.tab_bar.link.${status}`),
        path: this.localizeRouterService
          .translateRoute(`attendee.${status}`)
          .toString(),
      }))
    );
  }
}
